var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFortmatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1H8.49998H4.99999H1.5V4.50511V8.01022V8.23492V11.4949V11.5153V15H4.99999V11.5153V11.4949V8.23492V8.01022V4.50511H8.49998H12H15.5V1H12Z",
    fill: "#617BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.4898H11.9908V15H12.1137C13.0119 14.9995 13.8733 14.6423 14.5083 14.0072C15.1433 13.3719 15.5 12.5105 15.5 11.6125V8H8.5V11.4898Z",
    fill: "#617BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortmatic);
export default __webpack_public_path__ + "static/media/fortmatic.934be89ab8bf68ff34dc23a712c4c6d2.svg";
export { ForwardRef as ReactComponent };